var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section1"},[_c('div',{staticClass:"div_entrance"},[_c('ul',_vm._l((_vm.roles),function(nav,index){return _c('li',{key:index},[_c('a',{on:{"click":function($event){return _vm.$router.push(nav.path)}}},[_vm._v(_vm._s(nav.title))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }